import React, { useState } from 'react';
import SearchPage from './SearchPage';
import { fetchSearchPage, handleError } from '../../utils/lib';
import ListItemWAvatar from '../../layouts/ListItemWAvatar';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from '../../providers/SnackBarProvider';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const SearchTreatment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const snackbar = useSnackbar();
  
  const [openDialog, setOpenDialog] = useState(false);
  const [newTreatment, setNewTreatment] = useState({ name: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  
  const renderItem = (item) => (
    <Box
      sx={{
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleOnClick(item)}
    >
      <ListItemWAvatar 
        key={item.id} 
        primary={item.name}
      />
    </Box>
  );

  const handleOnClick = (treatment) => {
    const from = location.state?.from;
    const pet = location.state?.pet;
    if (from) {
      navigate(from, { state: { treatment, pet }, replace: true });
    }
  };

  const handleCreateNew = () => {
    setNewTreatment({ name: '' });
    setErrors({});
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    if (!isLoading) {
      setOpenDialog(false);
    }
  };

  const handleSaveTreatment = async () => {
    if (!newTreatment.name.trim()) {
      setErrors({ name: t('search.nameRequired') });
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}treatments`,
        newTreatment,
        { withCredentials: true }
      );

      newTreatment.id = response.data.data.id;
      
      //const createdTreatment = response.data.data;
      //snackbar('Tratamiento creado correctamente');
      setOpenDialog(false);
      
      // Si viene de otra página, navegar de vuelta con el tratamiento creado
      const from = location.state?.from;
      const pet = location.state?.pet;
      if (from) {
        navigate(from, { state: { treatment: newTreatment, pet }, replace: true });
      }
    } catch (error) {
      handleError(error, snackbar);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <SearchPage
        fetchFunction={fetchSearchPage}
        table={'treatments'}
        renderItem={renderItem}
        placeholder={t('search.searchTreatment')}
        createNew={handleCreateNew}
      />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{t('search.newTreatment')}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="normal"
            label={t('common.nameStar')}
            value={newTreatment.name}
            onChange={(e) => {
              setNewTreatment({ ...newTreatment, name: e.target.value });
              if (errors.name) setErrors({});
            }}
            error={!!errors.name}
            helperText={errors.name}
            disabled={isLoading}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSaveTreatment();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={isLoading}>
            {t('common.cancel')}
          </Button>
          <Button
            onClick={handleSaveTreatment}
            variant="contained"
            color="primary"
            disabled={isLoading || !newTreatment.name.trim()}
            startIcon={isLoading ? <CircularProgress size={20} /> : null}
          >
            {isLoading ? t('common.saving') : t('common.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SearchTreatment;

